<template>
  <div>
    <v-card class="pl-5 pr-5 pb-5">
      <div class="row">
        <div class="col">
          <h2>Deleted User Devices Count</h2>
          <v-divider></v-divider>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <ConfirmationDialog ref="confirm" />
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">User Name</th>
                  <th class="text-left">Email</th>
                  <th class="text-left">Devices Count</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in list" :key="item.id">
                  <td>{{ item.firstName }} {{ item.lastName }}</td>
                  <td>{{ item.email }}</td>
                  <td>{{ item.devicecount }}</td>                  
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </div>
      <v-overlay :value="overlay">
        <v-progress-circular
          indeterminate
          size="64"
        ></v-progress-circular>
      </v-overlay>
    </v-card>
  </div>
</template>
<script>
import * as api from "@/api";
import Notification from "@/components/Notification";
import ConfirmationDialog from "@/components/ConfirmationDialog";

export default {
  name: "UserDeviceDeleted",
  //props: {  userId: { type: Number, required: true },  },
  components: {
    Notification,
    ConfirmationDialog,
  },
  created() {
    this.getUserDevices();
  },
  methods: {
    getUserDevices() {
      let that = this;
      that.overlay = true;
      this.list = [];
      new Promise((resolve, reject) => {
        api
          .getAll("user-devices/devices/removed")
          .then((response) => {
            this.list = response.data;
            console.log(this.list)
            that.overlay =false
          })
          .catch((error) => {
            reject(error);
            that.overlay =false
          });
      });
    },

    async onDelete(obj) {
      //this.isEdit = false;
      if (
        await this.$refs.confirm.open(
          "Confirm",
          "Are you sure, Do you really want to delete this record?"
        )
      ) {
        new Promise((resolve, reject) => {
          api
            .DeleteByID("user-devices", obj.id)
            .then((response) => {
              resolve(response);
              if (response.status === 200 || response.status === 201) {
                this.notify.type = 1;
                this.notify.message = "Record successfully deleted";
                this.getUserDevices(this.userId);
                setTimeout(() => {
                  this.notify.type = 0;
                }, 3000);
              } else {
                this.notify.type = 4;
                this.notify.errors.push("Failed to save data.");
              }
            })
            .catch((error) => {
              this.notify.type = 4;
              this.notify.errors.push("Failed to save data. " + error);
              reject(error);
            });
        });
      }
    },
  },
  data() {
    return {
      list: [],
      notify: {
        type: 0,
        message: "",
        errors: [],
      },
      overlay: false
    };
  },
};
</script>


// WEBPACK FOOTER //
// src/components/UserDeviceDeleted.vue